import axios from "axios";
import { API_URL, LOGIN_URL } from "../../config/config";
import API from "../../common/API";

/*** 
@purpose : Get state list
@Parameter : {}
**/
export const fetchUserRole = async (token) => {
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_USER_ROLE + `?x-api-key=${token}&timestamp=${timestamp}`, { headers: { 'Access-Control-Allow-Origin': '*', mode: 'no-cors'}}).then((response) => {
    if (response.data) {
      return response.data;
    }
  });
};

/*** 
@purpose : Get allocated MR list
@Parameter : {}
**/
export const loginUser = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.LOGIN_USER, {
    method: "post",
    headers: {'Access-Control-Allow-Origin': '*', mode: 'no-cors'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get allocated MR list
@Parameter : {}
**/
export const languageChange = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return fetch(API_URL + API.LANGUAGE_CHANGE, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get notice list
@Parameter : {}
**/
export const fetchNoticeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_NOTICE_LISTING + `?timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}}).then((response) => {
    
    if (response.data.success == true && response.data.data) {
      return response.data.data;
    }
  });
};

/*** 
@purpose : Get state list
@Parameter : {}
**/
export const fetchStateList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_STATE_LIST + `?timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}}).then((response) => {
    if (response.data.success == true && response.data.data) {
      return response.data.data;
    }
  });
};

/***
@purpose : Get city list
@Parameter : {value}
**/
export const fetchCityList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_CITY_LIST + `?stateID=${value}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get allocated sales office list
@Parameter : {}
**/
export const fetchAllocatedSalesOfficeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_ALLOCATED_SALES_OFFICE_LIST + `?timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get classifications list
@Parameter : {}
**/
export const fetchClassificationsList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_ORG_CLASSIFICATION_LIST + `&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get ultmarc facility super type list
@Parameter : {}
**/
export const fetchUltmarcFacilitySuperTypeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_ULTMARC_FACILITY_SUPER_TYPE_LIST + `?timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get ultmarc facility type list
@Parameter : {value}
**/
export const fetchUltmarcFacilityTypeList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_ULTMARC_FACILITY_TYPE_LIST + `?facilityTypeOneID=${value}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get medical speciality super type list
@Parameter : {}
**/
export const fetchMedicalSpecialitySuperTypeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_MEDICAL_SPECIALITY_SUPER_TYPE_LIST + `&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get medical speciality type list
@Parameter : {}
**/
export const fetchMedicalSpecialityTypeList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_MEDICAL_SPECIALITY_TYPE_LIST + `?name="Org"&medicalSpecialityOneID=${value}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get BU list
@Parameter : {}
**/
export const fetchBUList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_BU_LIST + `?timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}}).then((response) => {
    if (response.data.success == true && response.data.data) {
      return response.data.data;
    }
  });
};

/*** 
@purpose : Get division list
@Parameter : {}
**/
export const fetchDivisionList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_DIVISION_LIST + `?buID=${value}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get branch list
@Parameter : {}
**/
export const fetchBranchList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_BRANCH_LIST + `?buID=${value.buID}&divisionID=${value.divisionID}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get sales office list
@Parameter : {}
**/
export const fetchSalesOfficeList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios.get(API_URL + API.GET_SALES_OFFICE_LIST + `?buID=${value.buID}&divisionID=${value.divisionID}&branchID=${value.branchID}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get delete reason list
@Parameter : {}
**/
export const fetchDeleteReasonList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_DELETE_REASON_LIST + `?timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get allocated MR list
@Parameter : {}
**/
export const getAllocatedMR = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return fetch(API_URL + API.GET_ALLOCATED_MR_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get organization Inquiry list
@Parameter : {}
**/
export const getOrganizationInquiryList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return fetch(API_URL + API.GET_ORGANIZATION_INQUIRY_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Change language
@Parameter : {body}
**/
export const changeLanguage = (body) => async (dispatch) => {
  // setItem(languageKey, body.language);
  const payload = {
    data: body.language,
  };
  await dispatch({ type: "language", payload });
};

/*** 
@purpose : Get individual organization details
@Parameter : {id}
**/
export const fetchOrganizationDetails = async(id) => {
  const token = sessionStorage.getItem("token");
  const wwid = sessionStorage.getItem("WWID")
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_ORGANIZATION_INFO + `?orgCustID=${id}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "wwid": wwid, mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      // if (response.data.success == true && response.data.data) {
        return response;
      // }
    });
};

/*** 
@purpose : Get child facilities details
@Parameter : {id}
**/
export const getChildFacilities = async(body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_CHILD_FACILITIES + `?orgCustID=${body.id}&limit=${body.limit}&totalRecords=${body.totalRecords}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      
      if (response.data.success == true && response.data.data) {
        return response.data;
      }
    });
};

/*** 
@purpose : Get parent facilities details
@Parameter : {id}
**/
export const getParentFacilities = async(body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_PARENT_FACILITIES + `?orgCustID=${body.id}&limit=${body.limit}&totalRecords=${body.totalRecords}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data;
      }
    });
};

/*** 
@purpose : Get affiliated person details
@Parameter : {id}
**/
export const getAffiliatedPersonDetails = async(body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_AFFILIATED_PERSON_DETAILS + `?orgCustID=${body.id}&limit=${body.limit}&totalRecords=${body.totalRecords}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data;
      }
    });
};

/*** 
@purpose : Get allocated employees details
@Parameter : {id}
**/
export const getAllocatedEmployeesDetails = async(body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_ALLOCATED_EMPLOYEES_DETAILS + `?orgCustID=${body.id}&limit=${body.limit}&totalRecords=${body.totalRecords}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data;
      }
    });
};

/*** 
@purpose : Get organization customer data for change request
@Parameter : {id}
**/
export const getOrganizationCustomerDetails = async(id) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return await axios
    .get(API_URL + API.GET_ORGANIZATION_CHANGE_REQUEST_DATA + `?orgCustID=${id}&timestamp=${timestamp}`, { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600}})
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        response.data.data[0].maintenanceWindowFlag = response.data.maintenanceWindowFlag
        return response.data.data;
      }
    });
};

/*** 
@purpose : Organization attribute change
@Parameter : {body}
**/
export const organizationAttributeChange = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.UPDATE_ORGANIZATION_CUSTOMER_DETAILS, {
    method: "post",
    headers: { 'x-api-key': token, 'wwid': wwid, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Organization closure
@Parameter : {body}
**/
export const organizationClosure = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.DELETE_ORGANIZATION_CUSTOMER, {
    method: "post",
    headers: { 'x-api-key': token, 'wwid': wwid, 'Access-Control-Allow-Origin': '*', mode: 'no-cors', 'Access-Control-Max-Age': 600},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};
